import config from 'utils/config';
import storage from '@xto10x/storage/lib';
import { StorageKey } from 'utils/constants';
import httpClient from '@xto10x/core/lib/httpClient';

const configApi = {
  postUserConfig: (data, preferenceType) => {
    const requestBody = {
      operation: 'create',
      user_email: storage.getDataFromLocal(StorageKey.USER_INFO).email,
      payload: {
        Item: {
          preference_type: preferenceType,
          user_id: storage.getDataFromLocal(StorageKey.USER_INFO)
            .user_reference_id,
          data
        }
      }
    };
    return httpClient
      .post(`${config.userConfigDynamoInvokeUrl}/user-preference`, requestBody)
      .then(async updatedData => {
        await configApi.getAllUserPreferences();
        return updatedData;
      });
  },
  getAllUserPreferences: () =>
    httpClient.get(
      `${config.userConfigDynamoInvokeUrl}/user-preference/${
        storage.getDataFromLocal(StorageKey.USER_INFO).user_reference_id
      }`
    ),
  getGlobalConfig: configType =>
    httpClient.get(
      `${config.userConfigDynamoInvokeUrl}/global-configs/${configType}`
    ),
  getBlitzRedirectsConfig: () =>
    httpClient.get(
      `${config.userConfigDynamoInvokeUrl}/public-configs?appName=blitz&configName=redirects`
    ),
  getPeopleCuesSubDomainRedirectsConfig: () =>
    httpClient.get(
      `${config.userConfigDynamoInvokeUrl}/public-configs?appName=people_cues_common&configName=peoplecues_redirects_config`
    )
};

export default configApi;
